import { mutationTypes } from '@/core/constants'
import { FiltroUtils } from '@/core/utils'

export default {
	[mutationTypes.TIPO.SET_FILTRO](state, filtro) {
		FiltroUtils.setarFiltro(state.filtro, filtro)
	},

	[mutationTypes.TIPO.SET_PAGINACAO](state, paginacao) {
		state.paginacao = paginacao
	},

	[mutationTypes.TIPO.POR_NUMERO_E_ITEM_PROCESSO.SET_FILTRO](state, filtro) {
		FiltroUtils.setarFiltro(state.porNumeroEItemProcesso.filtro, filtro)
	},

	[mutationTypes.TIPO.POR_NUMERO_E_ITEM_PROCESSO.SET_PAGINACAO](state, paginacao) {
		state.porNumeroEItemProcesso.paginacao = paginacao
	},
}
